import {
  FetchPdfBatchStatsRequest,
  FetchPdfBatchStatsSuccess,
  FetchPdfBatchStatsFailure,
  FetchPdfBatchTaskStatusRequest,
  FetchPdfBatchTaskStatusSuccess,
  FetchPdfBatchTaskStatusFailure,
  GeneratePdfBatchRequest,
  GeneratePdfBatchSuccess,
  GeneratePdfBatchFailure,
  StopPdfBatchGenerationRequest,
  StopPdfBatchGenerationSuccess,
  StopPdfBatchGenerationFailure,
} from './pdf-batch-generation.actions'
import { PdfBatchGenerationService } from './pdf-batch-generation.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SettingsTypes from './pdf-batch-generation.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class PdfBatchGenerationEffects {
  constructor(
    private actions: Actions,
    private pdfBatchGenerationService: PdfBatchGenerationService,
    private router: Router,
  ) {}

  FetchPdfBatchStats$ = createEffect(() =>
    this.actions.pipe(
      ofType(SettingsTypes.FETCH_PDF_BATCH_STATS_REQUEST),
      switchMap((action: FetchPdfBatchStatsRequest) => {
        return this.pdfBatchGenerationService.fetchPdfBatchStats().pipe(
          map((result) => {
            return new FetchPdfBatchStatsSuccess(result)
          }),
          catchError((err, caught) => {
            return of(new FetchPdfBatchStatsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
  FetchPdfBatchTaskStatus$ = createEffect(() =>
    this.actions.pipe(
      ofType(SettingsTypes.FETCH_PDF_BATCH_TASK_STATUS_REQUEST),
      switchMap((action: FetchPdfBatchTaskStatusRequest) => {
        return this.pdfBatchGenerationService.fetchBatchTaskStatus().pipe(
          map((result) => {
            return new FetchPdfBatchTaskStatusSuccess(result)
          }),
          catchError((err, caught) => {
            return of(new FetchPdfBatchTaskStatusFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  GeneratePdfBatch$ = createEffect(() =>
    this.actions.pipe(
      ofType(SettingsTypes.GENERATE_PDF_BATCH_REQUEST),
      switchMap((action: GeneratePdfBatchRequest) => {
        return this.pdfBatchGenerationService.generatePdfBatch().pipe(
          switchMap((result) => {
            return [
              new GeneratePdfBatchSuccess(result.data),
              new FetchPdfBatchTaskStatusRequest(),
            ]
          }),
          catchError((err, caught) => {
            return of(new GeneratePdfBatchFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  StopPdfBatchGeneration$ = createEffect(() =>
    this.actions.pipe(
      ofType(SettingsTypes.STOP_PDF_BATCH_GENERATION_REQUEST),
      switchMap((action: StopPdfBatchGenerationRequest) => {
        return this.pdfBatchGenerationService.stopPdfBatchGeneration().pipe(
          switchMap((result) => {
            return [
              new StopPdfBatchGenerationSuccess(result.data),
              new FetchPdfBatchTaskStatusRequest(),
            ]
          }),
          catchError((err, caught) => {
            return of(new StopPdfBatchGenerationFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
